import { useTranslation } from 'react-i18next';
import { Navigate, Outlet } from 'react-router-dom';

import { useMyProfile } from '@/features/profile';
import { Spinner } from '@/shared/ui/Spinner';

/** Guards every /admin/* route: non-admins get bounced home, non-authenticated
 * would have been caught earlier by RootGate. RLS still enforces server-side —
 * this only prevents the "empty admin page" UX from a direct URL hit. */
export function AdminGate(): JSX.Element {
  const { t } = useTranslation();
  const profile = useMyProfile();
  if (profile.isPending) {
    return (
      <div className="state">
        <Spinner />
        <span className="muted">{t('common.loading')}</span>
      </div>
    );
  }
  if (!profile.data?.isAdmin) return <Navigate to="/" replace />;
  return <Outlet />;
}
